export const EmailOptinToastShownKey = 'EmailOptinToastShown';
export const EmailOptinToastTimesShownKey = 'EmailOptinToastTimesShown';
export const EmailOptinToastTestName = 'intlEmailOptInFavorite';
